<template>
  <div class="help-page">
    <div class="help-page-header">
      <div class="r-index" @click="goHome">锦汇卡回收 ></div>
      <div class="txt-blue">卡券学堂</div>
    </div>
    <div class="help-page-content">
      <div class="help-page-content-left">
        <div v-for="item in categories" :key="item.id" style="width: 100%">
          <div
            class="help-page-content-left-item"
            :style="itemStyle(item)"
            @click="leftClick(item)"
          >
            <img :src="imageBaseUrl + item.wapImg" />
            <div class="item-title">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="help-page-content-right">
        <div class="right-item-content">
          <div
            class="right-item-view"
            v-for="(item, index) in schoolList"
            :key="item.id"
            @click="handleClick(item.id)"
          >
            <div>{{ index + 1 + ":" + item.title }}</div>
            <img src="@/assets/image/jinru.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


  <script>
import http from "@/utils/http/axios";

export default {
  components: {},
  mounted() {
    this.fetchCategories();
  },
  methods: {
    fetchCategories() {
      http
        .get("/product/type/list")
        .then((response) => {
          if (response.code === 200) {
            this.categories = response.data;
            if (this.categories.length > 0) {
              this.leftId = this.categories[0].id;
              this.getSchoolList();
            }
          }
        })
        .catch(() => {
          this.$message.error("发生意外异常");
        });
    },
    // 左边点击事件
    leftClick(e) {
      this.leftId = e.id;
      window.scrollTo(0, 0);
      this.getSchoolList();
    },

    handleClick(id){
        window.scrollTo(0, 0);
        this.$router.push({
          path: '/newsdetail',
          query: { id: id}
        })
    },

    getSchoolList() {
      http
        .get(
          "/article/school/list?pageSize=3&pageNum=1&prodType=" + this.leftId
        )
        .then((response) => {
          console.log(response);
          if (response.code === 200) {
            this.schoolList = response.rows;
          }
        });
    },

    // 计算每个左侧项目的样式
    itemStyle(item) {
      return this.leftId === item.id
        ? "background-color: #488eff; color: white"
        : "";
    },
    // 计算每个左侧项目的图片
    itemImage(item) {
      return this.leftId === item.id ? item.image1 : item.image;
    },
    goHome() {
      this.$router.push({ path: "/" });
    },
  },
  data() {
    return {
      //imageBaseUrl: "https://admin.huishouka.com.cn",
      imageBaseUrl:'',
      leftId: 0,
      newsDetail: {},
      leftTitle: "联系我们",
      categories: [],
      schoolList: [],
    };
  },
};
</script>

  <style lang="scss" scoped>
.dropdown-icon {
  width: 16px;
  height: 16px;
  transition: transform 0.3s ease;
  margin-left: 10px;
  cursor: pointer;
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);

  &.rotate {
    transform: rotate(180deg);
  }
}
.right-item-content {
  margin-top: 10px;
  padding: 20px;
  color: #000000e0;
  font-size: 18px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 8px;
  .right-item-view {
    height: 70px;
    border-bottom: 2px solid #e8e8e8;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    color: #000000e0;
  }
}

.help-page {
  background: #f8f8fa;
  padding: 0 120px;
  margin-top: 95px;

  .help-page-header {
    height: 44px;
    display: flex;
    align-items: center;

    .r-index {
      color: #000000a6;
      font-size: 14px;
      font-weight: 500;
      margin-right: 5px;
    }
    .txt-blue {
      font-size: 17px;
    }
  }

  .help-page-content {
    display: flex;
    justify-content: space-between;

    .help-page-content-left {
      width: 280px;
      background-color: white;
      border-radius: 10px;
      padding: 10px 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      .item-child {
        padding: 20px 0;
        width: 100%;
        text-align: center;
        padding-left: 32px;
        font-size: 17px;
      }
    }

    .help-page-content-left-item {
      display: flex;
      width: 100%;
      align-items: center;
      padding: 20px 20px;
      box-sizing: border-box;
      cursor: pointer;
      position: relative;
      justify-content: center;

      .item-title {
        font-size: 17px;
        margin-left: 10px;
      }

      img {
        &:first-child {
          height: 32px;
          width: 32px;
          flex-shrink: 0;
        }

        &[src*="gerenxiala"] {
          width: 16px;
          height: 16px;
          padding-left: 5px;
          flex-shrink: 0;
        }
      }
    }

    .help-page-content-right {
      margin-left: 20px;
      flex: 1;
      background-color: white;
      border-radius: 10px;

      .help-page-content-right-item {
        padding: 25px;

        .right-item-title {
          color: #000000e0;
          font-size: 24px;
          font-weight: 500;
        }

        .right-item-content {
          margin-top: 10px;
          padding: 20px;
          color: #000000e0;
          font-size: 18px;
          font-weight: 500;
          display: flex;
          flex-direction: column;
          background: #f8f8fa;
          border-radius: 8px;
        }

        .yellow-view {
          margin-top: 10px;
          padding: 20px;
          background: #fff4db;
          border-radius: 8px;
          box-sizing: border-box;
          color: #a95300;
          margin-bottom: 16px;
          padding: 12px 14px 12px 24px;
        }
      }
    }
  }
}
</style>
